import React from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import AddStock from './AddStock'

const AddStockWrapper = () => {
    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <AddStock />
            </div>
            <Footer />
        </div>
    )
}

export default AddStockWrapper